import type { RunningTask } from '../variant_workflow/redux';

export const RUNNING_TASK_TYPES = {
  REFRESH_AND_RECALCULATE: 'refresh_and_recalculate',
  VARIANT_CREATE: 'variant_create',
  VCF_VARIANT_CREATE: 'vcf_variant_create',
} as const;

export const VARIANT_CREATION_TASK_TYPES: readonly string[] = [
  RUNNING_TASK_TYPES.VARIANT_CREATE,
  RUNNING_TASK_TYPES.VCF_VARIANT_CREATE,
];

export const RUNNING_TASK_LABELS: Record<string, string> = {
  [RUNNING_TASK_TYPES.REFRESH_AND_RECALCULATE]:
    'Refresh and recalculate arguments for variant',
  [RUNNING_TASK_TYPES.VARIANT_CREATE]: 'Variant create',
  [RUNNING_TASK_TYPES.VCF_VARIANT_CREATE]: 'VCF variant create',
};

export const RUNNING_TASK_POLLING_INTERVAL = 3000;

export const RUNNING_TASK_STATUS_TAG_COLORS: Record<
  RunningTask['status'],
  string
> = {
  running: 'processing',
  completed: 'success',
  failed: 'error',
};
